var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.iconClass,attrs:{"viewBox":"0 0 1024 1024","fill":_vm.color},on:{"click":_vm.handleClick}},[_c('path',{attrs:{"d":"M662 170h148v86h-596v-86h148l44-42h212zM360 506l92 92-90 90 60 60 90-90 90 90 60-60-90-90 90-92-60-60-90 92-90-92zM256 810v-512h512v512q0 34-26 60t-60 26h-340q-34 0-60-26t-26-60z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }